/** @jsx jsx */

import { Colors } from '@zapier/design-system';
import { css, jsx } from '@emotion/react';

const DividerStyles = css({
  borderTop: `1px solid ${Colors.neutral300}`,
  marginTop: 4,
  marginBottom: 5,
});

export const Divider = () => <hr css={DividerStyles} data-zds />;
